/*** IMPORTS FROM imports-loader ***/
var define = false;

var native = require('./native'); // 本地接口
var util = require('./util'); // 工具
var conf = require('./conf');

var eventId = 0; // 事件id，自增

var event = {
  loginHandlers: [], // 登录回调队列

  loginAttach: function (callback, once) {
    this.loginHandlers.push({
      id: eventId,
      callback: callback,
      once: once
    });
    return eventId++;
  },

  loginDetach: function (eventId) {
    for (var i = 0; i < this.loginHandlers.length; i++) {
      if (eventId === this.loginHandlers[i].id) {
        this.loginHandlers.splice(i, 1);
      }
    }
  }
};

// 执行回调队列
function execHandlers(event, userId, jumpKey) {
  for (var i = 0; i < event.loginHandlers.length; i++) {
    var callback = event.loginHandlers[i].callback;
    typeof callback === 'function' && callback(userId, jumpKey);
    if (event.loginHandlers[i].once) {
      event.loginDetach(event.loginHandlers[i].id);
    }
  }
}

// 客户端登录事件
// GetUserInfo方法存在时，使用客户端session，反之，使用长session
native.attachNativeEvent('OnUserLogin', function (userId, jumpKey) {
  native.checkNativeFunction('GetUserInfo', function (exist) {
    if (exist === conf.NFERRORCODE_SUCCESS) {
      execHandlers(event, userId);
    } else {
      if (conf.autoJump) {
        util.jsonp({
          url: conf.jumpUrl,
          callback: 'callback',
          data: {
            u1: conf.jsonCallbackUrl + '?_=' + new Date().valueOf(),
            jump_key: jumpKey
          },
          success: function () {
            execHandlers(event, userId);
          }
        });
      } else {
        execHandlers(event, userId, jumpKey);
      }
    }
  });
});

module.exports = event;




//////////////////
// WEBPACK FOOTER
// ./event.js
// module id = 5
// module chunks = 0